module.exports = __webpack_public_path__ + "static/img/banner16.165b16d6.png";